var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCustomerName(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "16px",
    height: "20px",
    viewBox: "0 0 16 20",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-24-/-Outline-/-Core-UI-/-profile_",
    transform: "translate(-4.000000, -2.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    x: 4.9999926e-8,
    y: -5.68434189e-14,
    width: 24,
    height: 24
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20,18.07 C20,15 18.39,13 16,13 L8.00000005,13 C5.50000005,13 4.00000005,14.9 4.00000005,18.07 L4.00000005,22 L6.00000005,22 L6.00000005,18.07 C6.00000005,16 6.67000005,15 8.00000005,15 L16,15 C17.47,15 18,16.65 18,18.07 L18,22 L20,22 L20,18.07 Z M12,11.0000576 L12,11.0000576 C12.9246833,11.0053181 13.8134629,10.6423979 14.4701318,9.99135764 C15.1268006,9.34031737 15.4973582,8.4546948 15.5,7.53 L15.5,5.47 C15.4973582,4.5453052 15.1268006,3.65968263 14.4701318,3.00864236 C13.8134629,2.35760208 12.9246833,1.99468187 12,1.99994237 L12,1.99994237 C11.0753168,1.99468187 10.1865372,2.35760208 9.52986833,3.00864236 C8.87319946,3.65968263 8.50264194,4.5453052 8.50000005,5.47 L8.50000005,7.53 C8.50264194,8.4546948 8.87319946,9.34031737 9.52986833,9.99135764 C10.1865372,10.6423979 11.0753168,11.0053181 12,11.0000576 L12,11.0000576 Z M10.5,5.47 C10.4999178,5.07487782 10.6589037,4.69635828 10.941105,4.41980097 C11.2233063,4.14324366 11.6049602,3.99193627 12,4 L12,4 C12.3950399,3.99193627 12.7766938,4.14324366 13.0588951,4.41980097 C13.3410964,4.69635828 13.5000823,5.07487782 13.5,5.47 L13.5,7.53 C13.5000823,7.92512218 13.3410964,8.30364172 13.0588951,8.58019903 C12.7766938,8.85675634 12.3950399,9.00806373 12,9 L12,9 C11.6049602,9.00806373 11.2233063,8.85675634 10.941105,8.58019903 C10.6589037,8.30364172 10.4999178,7.92512218 10.5,7.53 L10.5,5.47 Z",
    id: "---\\u21B3-\\uD83C\\uDF08-Color",
    fillOpacity: 0.8,
    fill: "#000A19",
    fillRule: "evenodd"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCustomerName);
export default __webpack_public_path__ + "static/media/customer-name.5a2b27b84b4a40cbae868f7f840eb6dd.svg";
export { ForwardRef as ReactComponent };